import React from 'react';
import classNames from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import { FormattedMessage, useIntl } from '../../../../util/reactIntl';
import { ensureCurrentUser } from '../../../../util/data';
import { submitContactUs } from '../../../ContactUsPage/ContactUsPage.duck';
import { CheckCircle2Icon } from '../MerchantIcons';
import MerchantContactForm from './MerchantContactForm';
import css from './ContactCta.module.css';

const BENEFITS = [
  'ForBusiness.contactBenefit1',
  'ForBusiness.contactBenefit2',
  'ForBusiness.contactBenefit3',
];

const getInitialValues = currentUser => {
  const { email, profile } = currentUser?.attributes || {};
  const { firstName, lastName } = profile || {};
  const { phoneNumber, mobile_phone_number } = profile?.protectedData || {};

  return {
    name: [firstName, lastName].filter(Boolean).join(' '),
    email,
    mobile_phone_number,
    phoneNumber,
  };
};

const ContactCta = () => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const currentUser = useSelector(state => state.user?.currentUser);
  const { isSubmitting, submissionSuccess, submissionError } = useSelector(
    state => state.ContactUsPage
  );

  const arabicLanguage =
    typeof window !== 'undefined' && localStorage.getItem('language') === 'Arabic';

  const ensuredCurrentUser = ensureCurrentUser(currentUser);
  const isLoggedIn = !!currentUser?.id?.uuid;
  const initialValues = isLoggedIn ? getInitialValues(ensuredCurrentUser) : {};

  const handleSubmit = values => {
    const { phoneNumber, mobile_phone_number, ...rest } = values || {};

    const leadValues = {
      mobile: phoneNumber,
      isLead: true,
      ...rest,
    };

    const caseValues = {
      phone: phoneNumber,
      ...rest,
    };

    dispatch(submitContactUs(isLoggedIn ? caseValues : leadValues));
  };

  const supportEmail = intl.formatMessage({ id: 'ForBusiness.contactEmail' });

  return (
    <section
      id="contact"
      className={classNames(css.section, arabicLanguage && css.arabicDirection)}
    >
      <div className={css.inner}>
        <div className={css.gradientBlock}>
          <div className={css.grid}>
            <div className={css.copyCol}>
              <h2 className={css.title}>
                {intl.formatMessage({ id: 'ForBusiness.contactTitle' })}
              </h2>
              <p className={css.subtitle}>
                {intl.formatMessage({ id: 'ForBusiness.contactSub' })}
              </p>
              <ul className={css.benefits}>
                {BENEFITS.map(id => (
                  <li key={id} className={css.benefitItem}>
                    <CheckCircle2Icon className={css.benefitIcon} />
                    {intl.formatMessage({ id })}
                  </li>
                ))}
              </ul>
            </div>

            <div className={css.formPanel}>
              <div className={css.formTitle}>
                {intl.formatMessage({ id: 'ForBusiness.contactFormTitle' })}
              </div>
              <p className={css.formSub}>
                {intl.formatMessage(
                  { id: 'ForBusiness.contactFormSub' },
                  {
                    email: (
                      <span className={css.emailHighlight}>{supportEmail}</span>
                    ),
                  }
                )}
              </p>

              {!isSubmitting && submissionError ? (
                <p className={css.statusMessage}>
                  <FormattedMessage id="WishlistPage.somethingWentWrong" />
                </p>
              ) : null}

              {submissionSuccess ? (
                <p className={css.statusMessageSuccess}>
                  <FormattedMessage id="ContactUsPage.successMessage" />
                </p>
              ) : (
                <MerchantContactForm
                  key={isLoggedIn ? 'logged-in' : 'guest'}
                  intl={intl}
                  currentUser={currentUser}
                  onSubmit={handleSubmit}
                  arabicLanguage={arabicLanguage}
                  initialValues={initialValues}
                  inProgress={isSubmitting}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactCta;
